import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { AccountingReport } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUsePastDuePayments {
  productType?: string | null;
  billingSources?: string[];
  paymentMethods?: string[];
  enabled?: boolean;
}

function usePastDuePayments({
  productType,
  billingSources,
  paymentMethods,
  enabled = true,
}: IUsePastDuePayments): UseQueryResult<{ data: AccountingReport }> {
  const params: UrlParams = {};

  if (productType !== undefined && productType !== null) {
    params.product_type = productType;
  }
  if (billingSources !== undefined && billingSources.length > 0) {
    params.billing_sources = billingSources.join(',');
  }
  if (paymentMethods !== undefined && paymentMethods.length > 0) {
    params.payment_methods = paymentMethods.join(',');
  }

  return useQuery(
    ['past-due-payments', productType, billingSources, paymentMethods],
    () => client.get(`reports/past-due-payments?${encodeUrlParams(params)}`),
    {
      enabled: enabled,
      staleTime: 86400000, // 1 day
    },
  );
}

export default usePastDuePayments;
